import LoadingIndicator from '@/widgets/LoadingIndicator'
import NoResultsIndicator from '@/widgets/NoResultsIndicator'
import { getFilterIndicator, getSortIndicator } from '@/lib/tableHelpers'
import PlacowkiTableRow from './PlacowkiTableRow'

export default function PlacowkiTable({
	data,
	loading,
	sortColumn,
	sortDirection,
	onSort,
	selectedPlacowki,
	onSelectAll,
	onSelectPlacowka,
	isAllSelected,
	isIndeterminate,
	onMarkAsDone,
	onMarkAsUndone,
	processingId,
	hasPlacowkaFilter,
	onOpenPlacowkaFilter,
	hasMiastoFilter,
	hasGminaFilter,
	hasPowiatFilter,
	hasWojewodztwoFilter,
	hasTypFilter,
	hasTriageFilter,
	hasStatusFilter,
	onOpenMiastoFilter,
	onOpenGminaFilter,
	onOpenPowiatFilter,
	onOpenWojewodztwoFilter,
	onOpenTypFilter,
	onOpenTriageFilter,
	onOpenStatusFilter,
}) {
	const rows = Array.isArray(data) ? data : []

	if (loading) return <LoadingIndicator />

	return (
		<div className="mt-6 overflow-x-auto">
			<table className="min-w-full bg-white border border-gray-300 rounded-lg shadow">
				<thead>
					<tr>
						<th className="py-2 px-4 border-b border-gray-300 text-left w-12">
							<input
								type="checkbox"
								checked={isAllSelected}
								ref={el => {
									if (el) el.indeterminate = isIndeterminate
								}}
								onChange={e => onSelectAll(e.target.checked)}
								className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500 focus:ring-2"
							/>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<div className="inline-flex items-center gap-1">
								<button
									type="button"
									className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
									onClick={() => onSort('placowkaNazwa')}>
									Placowka
									{getSortIndicator('placowkaNazwa', sortColumn, sortDirection)}
								</button>
								<button
									type="button"
									className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
									onClick={onOpenPlacowkaFilter}
									title="Filtruj kolumne">
									{getFilterIndicator(hasPlacowkaFilter)}
								</button>
							</div>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<div className="inline-flex items-center gap-1">
								<button
									type="button"
									className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
									onClick={() => onSort('miastoNazwa')}>
									Miasto
									{getSortIndicator('miastoNazwa', sortColumn, sortDirection)}
								</button>
								<button
									type="button"
									className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
									onClick={onOpenMiastoFilter}
									title="Filtruj kolumne">
									{getFilterIndicator(hasMiastoFilter)}
								</button>
							</div>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<div className="inline-flex items-center gap-1">
								<button
									type="button"
									className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
									onClick={() => onSort('gminaNazwa')}>
									Gmina
									{getSortIndicator('gminaNazwa', sortColumn, sortDirection)}
								</button>
								<button
									type="button"
									className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
									onClick={onOpenGminaFilter}
									title="Filtruj kolumne">
									{getFilterIndicator(hasGminaFilter)}
								</button>
							</div>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<div className="inline-flex items-center gap-1">
								<button
									type="button"
									className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
									onClick={() => onSort('powiatNazwa')}>
									Powiat
									{getSortIndicator('powiatNazwa', sortColumn, sortDirection)}
								</button>
								<button
									type="button"
									className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
									onClick={onOpenPowiatFilter}
									title="Filtruj kolumne">
									{getFilterIndicator(hasPowiatFilter)}
								</button>
							</div>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<div className="inline-flex items-center gap-1">
								<button
									type="button"
									className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
									onClick={() => onSort('wojewodztwoNazwa')}>
									Wojewodztwo
									{getSortIndicator('wojewodztwoNazwa', sortColumn, sortDirection)}
								</button>
								<button
									type="button"
									className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
									onClick={onOpenWojewodztwoFilter}
									title="Filtruj kolumne">
									{getFilterIndicator(hasWojewodztwoFilter)}
								</button>
							</div>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<div className="inline-flex items-center gap-1">
								<button
									type="button"
									className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
									onClick={() => onSort('typNazwa')}>
									Typ
									{getSortIndicator('typNazwa', sortColumn, sortDirection)}
								</button>
								<button
									type="button"
									className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
									onClick={onOpenTypFilter}
									title="Filtruj kolumne">
									{getFilterIndicator(hasTypFilter)}
								</button>
							</div>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<div className="inline-flex items-center gap-1">
								<span className="font-semibold text-gray-700">Kategoria</span>
								<button
									type="button"
									className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
									onClick={onOpenTriageFilter}
									title="Filtruj kolumne">
									{getFilterIndicator(hasTriageFilter)}
								</button>
							</div>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<div className="inline-flex items-center gap-1">
								<span className="font-semibold text-gray-700">Status</span>
								<button
									type="button"
									className="ml-2 p-1 hover:bg-gray-100 rounded transition-colors duration-200 focus:outline-none focus:bg-gray-100"
									onClick={onOpenStatusFilter}
									title="Filtruj kolumne">
									{getFilterIndicator(hasStatusFilter)}
								</button>
							</div>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<button
								type="button"
								className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('doneDate')}>
								Data wykonania
								{getSortIndicator('doneDate', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-left">
							<button
								type="button"
								className="flex items-center gap-1 font-semibold text-gray-700 hover:text-blue-600 transition-colors duration-200 focus:outline-none focus:text-blue-600"
								onClick={() => onSort('doneByName')}>
								Wykonal
								{getSortIndicator('doneByName', sortColumn, sortDirection)}
							</button>
						</th>
						<th className="py-2 px-4 border-b border-gray-300 text-right font-semibold text-gray-700">
							Akcje
						</th>
					</tr>
				</thead>
				<tbody>
					{rows.map(item => {
						const placowkaId = item?.placowkaId
						return (
							<PlacowkiTableRow
								key={item._id || item.id || placowkaId}
								item={item}
								isSelected={selectedPlacowki.has(placowkaId)}
								onSelectPlacowka={onSelectPlacowka}
								onMarkAsDone={onMarkAsDone}
								onMarkAsUndone={onMarkAsUndone}
								processingId={processingId}
							/>
						)
					})}
				</tbody>
			</table>
			{rows.length === 0 ? (
				<div className="py-4">
					<NoResultsIndicator
						message="Nie znaleziono placowek w kampanii"
						description="Sprobuj zmienic wyszukiwanie lub filtry"
					/>
				</div>
			) : null}
		</div>
	)
}
